import React, { useState } from "react";
import Sidebar from "../components/Sidebar/Sidebar";
import Header from "../components/Navbar/Navbar";

const NonAuthLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false); // start collapsed on mobile
  const [sidebarDesktop, setSidebarDesktop] = useState(true); // expanded on desktop

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar */}
      <Sidebar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        sidebarDesktop={sidebarDesktop}
        setSidebarDesktop={setSidebarDesktop}
      />

      {/* Main Content */}
      <div className="flex-1 flex flex-col transition-all duration-300">
        {/* Header */}
        <Header
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          sidebarDesktop={sidebarDesktop}
          setSidebarDesktop={setSidebarDesktop}
        />

        {/* Page content */}
        <main className="p-6 overflow-auto">{children}</main>
      </div>
    </div>
  );
};

export default NonAuthLayout;
